module.exports = __webpack_public_path__ + "img/gift_banner.jpg?v=47f8011c";